import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NoticeComponent } from '../components/notice/notice.component';

@Injectable({
  providedIn: 'root'
})

export class DialogService {
  modelWidth = '1170px';
  modelHeight = '92vh';
  config: MatDialogConfig = {
    width: this.modelWidth,
    maxWidth: this.modelWidth,
    maxHeight: this.modelHeight,
    height: this.modelHeight,
    disableClose: true,
    autoFocus: true,
    panelClass: 'custom-scroll'
  }
  constructor(public dialog: MatDialog) { }

  openDialog<T>(T, data: any = undefined, dialogConfigData: MatDialogConfig = this.config): MatDialogRef<T> {
    if (data)
      dialogConfigData.data = data;
    return this.dialog.open(T, dialogConfigData);
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  openNoticeDialog(message: string) : MatDialogRef<NoticeComponent> {
    return this.dialog.open(NoticeComponent, {
      width: 'fit-content',
      data: { message: message },
      disableClose: false,
      autoFocus: true,
      panelClass: 'search-dialog-container'
    });
  }
}
